import React, { Component } from 'react';
import { connect } from 'react-redux';
// components
import { Button } from 'reactstrap';
import CropperModal from 'components/modals/CropperModal';
import { ButtonBar, Table, InlineSync, FontAwesome } from 'components/ui';
// local modals
import BulkUploadModal from './BulkUploadModal';
import NewSoldierModal from './NewSoldierModal';
// functions
import is from 'is_js';
import { setTitle, canDownload } from 'functions/utils';
import { showError } from 'functions/notifications';
// styles
import './SoldiersPage.scss';
// state
import { 
  uploadProfile, getSoldiers, createSoldier,
  updateSoldier, uploadSpreadsheet 
} from 'store/base/soldiers/operations';
// data
import getColumns, { isIncomplete } from './columns';
import { isBC } from 'functions/login';
// csv react component
import { CSVLink } from "react-csv";
import { dataToCSV } from 'functions/utils/csv';

const defaultCropperModalSettings = {
  show: false,  src: false, id: false
}

export class SoldiersPage extends Component {
  // initial state
  state = {
    cropper: {
      ...defaultCropperModalSettings
    },
    upload: { show: false },
    create: { show: false, image: {} },
  }
  // load the contents if we do not have any
  componentDidMount(){
    const isCamp = this.props.login && this.props.login.code === 'CAMP';
    setTitle( isCamp ? 'View/Edit Campers' : 'View/Edit Soldiers' );
    this.getSoldiers();
  }

  getSoldiers = () => {
    showError( this.props.getSoldiers( true ) );
  }

  // close the cropper modal
  closeCropperModal = () => this.setState({ cropper: {
    ...defaultCropperModalSettings
  } } );
  // toggle the modals
  toggleModal = key => () => this.setState({
    [ key ]: { ...this.state[ key ], show: !this.state[ key ].show }
  });

  // handler for pressing the picture
  editPicture = id => ({ target }) => this.setState({ 
    cropper: { show: true, id, src: target.src } 
  });

  // handler for when images are updated
  updatePicture = formData => {
    const { cropper, create } = this.state;
    if ( cropper.id )
      this.props.updateSoldier( cropper.id, formData );
    else
      this.props.uploadProfile( formData )
      .then( res => this.setState({ create: { ...create, image: res } }) );
    // close the cropper modal
    this.closeCropperModal();
  }
  // update soldiers when the toggle is changed
  updateToggle = ( key, id ) => e => showError(
    this.props.updateSoldier(
      id, { [key]: e.target.checked ? 1 : 0 }
    ));
  // handler for uploding the excel file
  uploadSpreadsheet = ( formData ) => showError( 
    this.props.uploadSpreadsheet( formData )
    .then( () => {
      this.setState({ upload: { show: false } }); 
      return this.getSoldiers();
    })
  );
  // create a new soldier
  createSoldier = soldier => {
    return this.props.createSoldier( soldier )
      .then( () => {
        this.setState({ create: { show: false, image: {} } } ) } )
  }

  // download the content as a CSV
  // toCSV = () => {
  //   const headers = [
  //     'Serial Number', 'First Name', 'Last Name', 'DOB', 'Gender', 'Registered', 
  //     'Chayolei', 'Tehillim', 'Chidon', 'Platoon', 'Base'
  //   ];
  //   // get the data
  //   const rows = this.props.soldiers.map( soldier => [
  //     soldier.user_serial, soldier.first, soldier.last, soldier.dob, soldier.gender, 
  //     soldier.user_registered, soldier.chayolei, soldier.yan, soldier.chidon,
  //     soldier.platoon ? `="${soldier.platoon.name}"` : '-', soldier.school.school_name
  //   ]);
  //   arrayToCSV( headers, rows, 'soldiers' );
  // }

  // download the content as a CSV
  toCSV = () => {
    const headers = [
      'Serial Number', 'First Name', 'Last Name', 'שם פרטי', 'שם משפחה', 'DOB', 'Gender', 'Registered', 
      'Chayolei', 'Tehillim', 'Chidon', 'Lulav', 'Platoon', 'Base', 'Rank', 'Family ID', 'Email', 'Work Phone', 'Home Phone', 'Cell Phone 1', 'Cell Phone 2'
    ];
    // get the data
    const rows = this.props.soldiers.map( soldier => [
      soldier.user_serial, soldier.first, soldier.last, soldier.first_he, soldier.last_he, soldier.dob, soldier.gender, 
      soldier.user_registered, soldier.chayolei, soldier.yan, soldier.chidon, soldier.lulav,
      soldier.platoon ? `="${soldier.platoon.name}"` : '-', soldier.school.school_name, soldier.rank_name, soldier.admin_id, 
      soldier.email, soldier.work_phone, soldier.home_phone, soldier.mobile_phone, soldier.mobile_phone2 
    ]);
    return dataToCSV( headers, rows );
  }

  // render the page
  render() {
    const { login, soldiers, loading } = this.props;
    const { cropper, upload, create } = this.state;
    const isCamp = login.code === 'CAMP';
    const columns = getColumns( login, this.editPicture, this.updateToggle );
    // page definition
    return (
      <div id='SoldiersPage' className='full-height'>

        <ButtonBar>
          <Button color='primary' onClick={ this.toggleModal('create') }>
           <FontAwesome icon='plus' /> { isCamp ? 'Add Camper' : 'Add Soldier' }
          </Button>
          <Button color='primary' onClick={ this.getSoldiers }>
            <InlineSync loading={ loading } /> Refresh
          </Button>
          { ( isBC( login.code, true ) || isCamp ) && is.not.mobile() && is.not.ios() &&
            <Button color='primary' onClick={ this.toggleModal('upload') }>
              <FontAwesome icon='file-upload' /> { isCamp ? 'Upload Camper List' : 'Upload Soldier List' }
            </Button>
          }
          { canDownload( soldiers ) &&
            <CSVLink
              data = { this.toCSV() }
              filename = { isCamp ? 'campers.csv' : 'soldiers.csv' }
              target = "_blank"
            >
              <Button color='primary'>
                <FontAwesome icon='file-download' /> { isCamp ? 'Download Campers (CSV/Excel)' : 'Download Soldiers (CSV/Excel)' }
              </Button>
            </CSVLink>
          }
        </ButtonBar>

        <Table
          columns={ columns }
          data={ soldiers }
          loading={ loading && !soldiers.length }
          getTrProps={ ( state, rowInfo ) => (
            rowInfo && isIncomplete( rowInfo.original ) ? { className: 'missing-info' } : {}
          )}
          pageId='SoldiersPage' />

        <CropperModal
          src={ cropper.src } 
          isOpen={ cropper.show }
          toggle={ this.closeCropperModal }
          uploadImage={ this.updatePicture } />

        <NewSoldierModal
          image={ create.image }
          isOpen={ create.show }
          onSubmit={ this.createSoldier }
          toggle={ this.toggleModal('create') }
          editPicture={ this.editPicture( false ) } />

        {/* Only show the uploader for base commanders and camp admins */
          ( login.code === 'BC' || login.code === 'CAMP' ) &&
          <BulkUploadModal
            inst={ this.props.login.inst_id }
            isOpen={ upload.show }
            upload={ this.uploadSpreadsheet }
            toggle={ this.toggleModal('upload') } />
        }
      </div>
    );
  }

}

const mapStateToProps = ({ base, login }) => {
  return {
    ...base.soldiers,
    login: login.current_login
  };
}

const mapDispatchToProps = {
  uploadProfile, getSoldiers, createSoldier,
  updateSoldier, uploadSpreadsheet
}

export default connect( mapStateToProps, mapDispatchToProps )( SoldiersPage );



// WEBPACK FOOTER //
// ./src/pages/base-managment/soldiers/SoldiersPage/SoldiersPage.jsx